/**
 * Roverpass wordmark + camper icon.
 *
 * Full logo is the horizontal PNG in `/public/logo.png` — a white wordmark
 * built for the dark navy (`#17232C`) chrome it renders on (sidebar, login).
 *
 * Compact variant (icon-only) is the camper inside the coral circle, used
 * for tight headers and the favicon.
 */

interface LogoProps {
  className?: string;
  /** When true, only the camper icon is rendered (no wordmark). */
  compact?: boolean;
}

export function Logo({ className, compact = false }: LogoProps) {
  if (compact) {
    return (
      <svg
        viewBox="0 0 343 343"
        className={className}
        role="img"
        aria-label="Roverpass"
      >
        <circle cx="171.5" cy="171.5" r="161.5" fill="#FF5252" />
        <path
          d="M281.4 231H264.8c.6-1.3 1-2.7 1.3-4.1 2.4-12 5.2-30.1 5.5-49.6h-17.5c-1.8 0-3.3-1.4-3.3-3.2v-33.5c0-1.8 1.5-3.3 3.3-3.3h15c-.8-5.7-1.7-10.7-2.6-14.8-1.8-8.4-9.1-14.4-17.6-14.4h-5.1V104c0-3.2-2.6-5.7-5.9-5.7H92.8c-3.3 0-5.9 2.5-5.9 5.7v4h-3.9c-9 0-16.6 6.6-17.9 15.5-1.7 11.5-3.5 29-3.5 51.2 0 19.9 2 38.6 3.8 51.1 1.3 8.9 8.9 15.5 17.9 15.5h3a59 59 0 0 1-.1-2.5c0-16.9 13.6-30.6 30.5-30.6s30.5 13.7 30.5 30.6c0 .9-.1 1.7-.1 2.5h26V136.2c0-9 7.3-16.3 16.2-16.3h27.3c8.9 0 16.3 7.3 16.3 16.3v105.2h48.5c1.6 0 2.8-1.2 2.8-2.8v-4.8c0-1.6-1.2-2.8-2.8-2.8z"
          fill="#FFF"
        />
      </svg>
    );
  }
  return <img src="/logo.png" alt="Roverpass" className={className} />;
}
